import { Pipe, PipeTransform } from '@angular/core';
import _ from 'lodash';
import { Observable, isObservable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
   name: 'isEmpty',
})
export class IsEmptyPipe implements PipeTransform {
   transform(value: Observable<any> | any): Observable<boolean> {
      const value$ = isObservable(value) ? value : of(value);
      return value$.pipe(map((val) => _.isEmpty(val)));
   }
}
